// extracted by mini-css-extract-plugin
module.exports = {"columns":"style_columns_MKdNK","myContentsDiv":"style_myContentsDiv_1byD1","column":"style_column_17Z3R","searchIcon":"style_searchIcon_3xdtI","txtSearch":"style_txtSearch_3LkDN"};